import React from "react";
import { Container, Row, Col, Card, CardBody,Button } from "reactstrap";
import TableContainerMin from "../../../../common/TableContainerMin";
import { Skeleton, Modal } from "antd";
import { ScheduleOutlined, DownloadOutlined,LoginOutlined } from "@ant-design/icons";
import vectorIcon from "../../../../assets/images/menu-alt-2.png";
import vector from "../../../../assets/images/Vector.png";
import AddEditDevForm from "../component/addEditDevForm.js";
import DetailBusiness from "../component/detailMerchent.js";
import CompleteCompanymerchent from "../../../company/component/completeCompany.js";
import '../utils/style.css';
import DeleteModalOTP from "../../../../common/delete/modalDeleteOtp.js";
import ManageMerchent from "../component/manageMerchant.js";
import FiltrerMerchentModal from "../component/FiltrerMerchentModal .js";
import TrierMerchentModal from "../component/TrierMerchentModal.js";
import KycMerchent from "../component/rappelValidate.js";
const ReconciliationHebdomadaire = ({
  searchTerm,
  setSearchTerm,
  openModal,
  renderTabs,
  columnsHebdomadaire,
  filteredMerchents,
  isLoading,
  isError,
  empty,
  modalState,
  setModalState,
  selectedMerchant,
  setIsModalOpen,
  isModalOpen,
  modalPosition,
  handleDetail,
  handleConnectClient,
  handleRappel,
  handleDelete,
  closeDeleteConfirmModal,
  isDeleting,
  currentuser,
  handleApplyFilters,
  setSortOrder
}) => {

  return (
    <React.Fragment>
        <div className="header-actions w-100 mb-2">
          <div className="col-6 p-0">
            <input
              type="text"
              placeholder="Rechercher un rapport..."
              className="form-control search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <Button className="filtrer" onClick={() => openModal("merchent-filtrer")}>
            <ScheduleOutlined style={{ fontSize: "20px" }} />
            Date
          </Button>
          <Button className="filtrer" onClick={() => openModal("merchent-trier")}>
            <DownloadOutlined  style={{fontSize: "20px"}} />
            Exporter
          </Button>
        </div>
         <Row className="w-100 m-0">
        <Col className="w- p-0">
        <Card className="h-100 w-100" style={{ border: "1px solid #E3E3E3" }}>
        <CardBody className="p-0 ">
        {renderTabs}
        <TableContainerMin
          columns={columnsHebdomadaire}
          data={filteredMerchents}
          isGlobalFilter={false}
          customPageSize={10}
          isLoading={isLoading}
          className="custom-header-css"
          divClass="table-responsive "
          tableClass="table w-100 mb-0 no-column-borders"
          theadClass="custom-thead"
          SearchPlaceholder="Recherche..."
         
        />
        {isLoading && !isError && (
          <div className="text-center"><Skeleton/> </div>
        )}
        {filteredMerchents && filteredMerchents.length === 0 && !isLoading && (
          <div className="text-center">
            <img
              src={empty} 
              alt="Liste vide"
              style={{ width: "150px", marginBottom: "10px" }}
            />
            </div>
        )}
      </CardBody>
    </Card>
  </Col>
</Row>
  <Modal
    open={isModalOpen}
    onCancel={() => setIsModalOpen(false)}
    footer={null}
    width={270}
    style={{
      background:"#FFFFFF",
      position: "absolute",
      top: modalPosition.top,
      left: modalPosition.left,
      borderRadius: 10,
      border: "1px solid #DFDFDF",
      padding: 0,
      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    }}
   bodyStyle={{ padding: "8px 1px" }}

    mask={false}
    closable={false}
  >
    <div
      style={{
        display: "flex",
        flexDirection: "column",
         alignItems: "flex-start",
        gap: "12px",
      }}
    >
      <a
      onClick={() => {
         handleDetail(selectedMerchant)
        setIsModalOpen(false);
      }}
      style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
    >
     <img src={vectorIcon} alt="Voir détails" style={{ width: 20, height: 20 }} />

      <span class="actions">Voir rapport</span>
    </a>
<a
  onClick={() => {
    handleConnectClient(selectedMerchant);
    setIsModalOpen(false);
  }}
  style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
>
  <LoginOutlined size={60} />
  
  <span className="actions">Connecter à l'espace client</span>
</a>
<a
      onClick={() => {
        if (selectedMerchant?.active) {
          openModal("disable", selectedMerchant);
        } else {
          openModal("valid", selectedMerchant);
        }
        setIsModalOpen(false);
      }}
      style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
    >
      <img
        src={selectedMerchant?.active ? vector : vector}
        alt={selectedMerchant?.active ? "Désactiver" : "Activer"}
        style={{ width: 14, height: 20 }}
      />
      <span className="actions">
        {selectedMerchant?.active ? "Désactiver le compte" : "Activer le compte"}
      </span>
    </a>
    <a
      onClick={() => {
        if (selectedMerchant?.kycVerified) {
          handleRappel("disable", selectedMerchant);
        } else {
          handleRappel("valid", selectedMerchant);
        }
        setIsModalOpen(false);
      }}
      style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
    >
      <img
        src={selectedMerchant?.kycVerified ? vector : vector}
        alt={selectedMerchant?.kycVerified ? "Désactiver" : "Activer"}
        style={{ width: 14, height: 20 }}
      />
      <span className="actions">
        {selectedMerchant?.kycVerified ? "Désactiver le kyc" : "Activer le kyc"}
      </span>
    </a>
      
    </div>
  </Modal>
          {modalState.type === "edit" && (
            <AddEditDevForm
              modal={modalState.type === "edit"}
              setModal={setModalState}
              toggle={() => openModal("edit", modalState.data)}
              selectedMerchent={modalState.data}
              currentuser={currentuser}
            />
          )}
          {isLoading ? (
        <Skeleton
         
        />
      ) : (
        <DetailBusiness
          modal={modalState.type === "detail"}
          setModal={setModalState}
          toggle={() => openModal("detail", modalState.data)}
          selectedMerchent={modalState.data}
          currentuser={currentuser}
          isLoading={false}
        />
      )}

          {modalState.type === "complete" && (
            <CompleteCompanymerchent
              modal={modalState.type === "complete"}
              setModal={setModalState}
              toggle={() => openModal("complete", modalState.data)}
              selectedCompany={modalState.data}
              currentuser={currentuser}
            />
          )}

          {modalState.type === "delete" && (
            <DeleteModalOTP
              isOpen={true}
              title={`du business ${modalState.data.merchentName}`}
              loading={isDeleting}
              onCancel={closeDeleteConfirmModal}
              onConfirm={() => handleDelete(modalState.data.merchentId)}
            />
          )}

          {modalState.type === "valid" && (
            <ManageMerchent
              modal={modalState.type === "valid"}
              setModal={setModalState}
              toggle={() => openModal("valid", modalState.data)}
              selectedMerchent={modalState.data}
              mode="validate"
            />
          )}

          {modalState.type === "disable" &&(
            <ManageMerchent
              modal={modalState.type === "disable"}
              setModal={setModalState}
              toggle={() => openModal("disable", modalState.data)}
              selectedMerchent={modalState.data}
              mode="disable"
            />
          )}
         {modalState.type === "rappel" && (
            <KycMerchent
              modal={true}
              setModal={setModalState}
              toggle={() => setModalState({ type: null })}
              selectedMerchent={modalState.data}
              mode={modalState.action}            
            />
            )}
           {modalState.type === "merchent-filtrer" && (
              <FiltrerMerchentModal
                isOpen={modalState.type === "merchent-filtrer"}
                toggle={() => openModal("merchent-filtrer", modalState.data)}
                onApply={handleApplyFilters}
                
              />
            )}
            {modalState.type === "merchent-trier" && (
            <TrierMerchentModal
              isOpen={modalState.type === "merchent-trier"}
              toggle={() => openModal("merchent-trier", modalState.data)}
              onApplySort={(order) => setSortOrder(order)}
            />
          )}
       
     
    </React.Fragment>


  );
};

export default ReconciliationHebdomadaire;